import { Tooltip, Typography } from "antd"
import moment from "moment"
import React from "react"
import MachineDetails from "./MachineDetails"
import { OrderAndPrefix } from "../../Orders/Helpers/OrderAndPrefix"

const { Text, Link } = Typography

//columns for arsoma printing cols
export const tapePrintingColumns = [
  {
    title: "Nr.",
    dataIndex: "orderNumber",
    align: "center",
    sorter: (a, b) => a.orderNumber - b.orderNumber,
    render: (value, record) => OrderAndPrefix(record),
  },
  {
    title: "Client",
    dataIndex: ["client", "client"],
    align: "center",
    ellipsis: {
      showTitle: false,
    },
    render: (item) => (
      <Tooltip placement="topLeft" title={item}>
        {item}
      </Tooltip>
    ),
  },
  {
    title: "Manager",
    dataIndex: "user",
    ellipsis: {
      showTitle: false,
    },
    align: "center",
    render: (item) => (
      <Tooltip placement="topLeft" title={item}>
        {item}
      </Tooltip>
    ),
  },
  {
    title: "Product",
    dataIndex: ["selectedProduct", "product", "productName"],
    align: "center",
  },
  {
    title: "Manufacturer",
    dataIndex: ["manufacturer", "company"],
    align: "center",
  },
  {
    title: "Boxes",
    dataIndex: ["boxCount"],
    align: "center",
  },
  {
    title: "Rolls",
    dataIndex: ["rollCount"],
    align: "center",
  },
  {
    title: "Tape Width",
    dataIndex: ["selectedProduct", "tapeWidth"],
    align: "center",
  },
  {
    title: "Material",
    dataIndex: ["selectedProduct", "material"],
    align: "center",
    ellipsis: {
      showTitle: false,
    },
    render: (item) => (
      <Tooltip placement="topLeft" title={item}>
        {item}
      </Tooltip>
    ),
  },
  {
    title: "Created",
    dataIndex: "created",
    align: "center",
    sorter: (a, b) => a.date.created.seconds - b.date.created.seconds,
    render: (value) => (
      <>
        <Text>{moment.unix(value.seconds).format("DD/MM/YYYY")}</Text>
      </>
    ),
  },
  {
    title: "Attachment",
    dataIndex: "technicalPage",
    align: "center",
    render: (value) => (
      <Link type="text" rel="noreferrer" target="_blank" href={value}>
        {value ? "Link" : ""}
      </Link>
    ),
  },
  {
    title: "Details",
    align: "center",
    render: (value) => <MachineDetails data={value} />,
  },
]
